module.exports = __webpack_public_path__ + "img/Tabs.54e9d244.png";